module.exports = __webpack_public_path__ + "static/shopify-product-feed-optimization-checklist-82b49c70c72788c50fd7cbd154ca9dd8.jpg";